export default __webpack_public_path__ + "static/media/mobile-svgrepo-com.d938be47.svg";